import React from 'react';
import loadable from '@loadable/component';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from '../../../../common/components';
// Routes
const ListCitiesPage = loadable(() => import('./ListCitiesPage'), {
  fallback: <Loader />
});
const AddCitiesPage = loadable(() => import('./AddCitiesPage'), {
  fallback: <Loader />
});
const EditCitiesPage = loadable(() => import('./EditCitiesPage'), {
  fallback: <Loader />
});
const CitiesRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListCitiesPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddCitiesPage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditCitiesPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
CitiesRoute.propTypes = {
  t: PropTypes.func
};
export default CitiesRoute;
